import { render, staticRenderFns } from "./cardOffice.vue?vue&type=template&id=48f15af4&scoped=true"
import script from "./cardOffice.vue?vue&type=script&lang=js"
export * from "./cardOffice.vue?vue&type=script&lang=js"
import style0 from "./cardOffice.vue?vue&type=style&index=0&id=48f15af4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f15af4",
  null
  
)

export default component.exports